module.exports = __webpack_public_path__ + "img/IMG_8992.f599a3d1.jpg";